import { Space } from 'interfaces/space';
import { SPACE_QUERY } from './queries';

export const getSpaceInfo = (client, data, communityId) => {
  const spaces: Space[] = [];
  data?.community?.communitySections?.edges?.forEach((section) => {
    section?.node?.communitySpaces?.edges?.forEach((space) => {
      // Performance Improvement
      // Since the SectionList query fetches all of the data required for the CommunitySpace query,
      // we can preload the apollo cache with that data. Any subsequent CommunitySpace query will
      // come from the cache instead of the server.
      client.writeQuery({
        query: SPACE_QUERY,
        data: {
          community: {
            __typename: 'Community',
            id: communityId,
            communitySpace: space.node,
          },
        },
        variables: {
          spaceId: space.node.id,
          communityId,
        },
      });
      spaces.push({
        id: space.node.id,
        name: space.node.name,
        iconName: space.node?.iconName,
        isExclusive: space.node?.isExclusive,
        description: space.node?.description,
      });
    });
  });
  return spaces;
};
